export const blurbText =
  'Some of the information captured may not auto-fill on the lead form. All captured information will be saved for future reference.'
export const blurbTextLead = 'Captured webform info will auto-fill below.'
export const blurbTextLeadNonWeb = 'Captured info will auto-fill below.'

export const filterFieldNames: string[] = [
  'BillToId',
  'BranchId',
  'CampaignId',
  'Country',
  'LocationId',
  'LocationTypeId',
  'DivisionId',
  'SourceId',
  'UserId',
  'UserName',
  'CustomFieldValues',
]

export const keyNameReplacements = (t) => {
  return [
    { oldKey: 'StateAbbreviation', newKey: t('state') },
    { oldKey: 'AddressLine1', newKey: 'Address' },
    { oldKey: 'AddressLine2', newKey: 'Apt / Suite' },
  ]
}

export enum draftLeadCapturedInfoItemNames {
  EmailAddress = 'EmailAddress',
}
